export default "__VITE_ASSET__CjT1aA3r__"